/**
 * Create a component structure for use as the wrapper of the load state
 * of all components wrapped within.
 * @param {string} storeModuleName
 * @returns {Object}
 */
export default function createComponent({storeModuleName}) {
    return {
        template: `
            <div> 
                <div v-if='!loading'>
                    <slot name="inner-component">
                        <span>Please wait...</span>
                    </slot>
                </div>
                <slot v-if='loading'></slot>
            </div>`,
        computed: {
            loading() {
                if (this.$store) {
                    return this.$store.getters[`${storeModuleName}/aggregateLoadingState`];
                }
                throw new TypeError('Vuex store is not available.');
            },
        },
    };
}
